import React from 'react';

const IntegrateIcon = ({ color = '#36737A', size = '24' }: { color?: string, size?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.053 16C18.58 18.961 15.532 21 12 21C8.468 21 5.42 18.961 3.947 16M20.053 8C18.58 5.039 15.532 3 12 3C8.468 3 5.42 5.039 3.947 8M10 12H3M10 12L8 10M10 12L8 14M14 12H21M14 12L16 14M14 12L16 10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IntegrateIcon;
